/* ─── GSAP 统一入口 ───
 * 全站只从这里取 gsap / useGSAP，集中注册插件与默认值，避免重复 registerPlugin。
 * 当前只用核心 GSAP（入场编排 + 弹窗/下拉/抽屉微交互），暂不引 ScrollTrigger 等插件。
 *
 * 约定：
 *  - 动效一律走 transform / opacity（合成器友好），不动 layout 属性。
 *  - reduce-motion 与「桌面/移动」门控统一用 gsap.matchMedia()，到点自动 revert。
 *  - 入场用 .from() 而非预置 opacity:0 的 set()——JS 不跑时元素仍是自然可见态，
 *    杜绝「脚本失灵则空白」；useGSAP 跑在 useLayoutEffect(绘制前)，.from() 不会闪现。
 */
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);

// 克制快速的全局默认：短时长 + power 缓出。各处可按需覆写 duration/ease。
gsap.defaults({ ease: 'power2.out', duration: 0.4 });

export { gsap, useGSAP };
